import moment from "moment";

export const formatDate = (props, date, type) => {
    let day = new Date(date).toLocaleDateString('en', { day: 'numeric' });
    // let month = new Date(date).toLocaleDateString(props.locale, {
    //   month: 'long',
    // });
    let month = new Date(date).toLocaleDateString('en', { month: 'numeric' });
    let year = new Date(date).toLocaleDateString('en', {
      year: 'numeric' /*,hour: 'numeric',minute: 'numeric',*/,
    });
    switch (type) {
      case 1: {
        return `${getZero(day)}-${getZero(month)}-${year}`;
      }
      case 2: {
        return `${month} ${day}, ${year}`;
      }
      case 3: {
        return `${getZero(day)}/${getZero(month)}/${year}`;
      }
      case 4: {
        return `${getZero(day)}/${getZero(month-1)}/${year}`;
      }
      case 5: {
        return (
          date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
        );
      }
      default: {
        break;
      }
    }
  };

export function getZero(num) {    // 个位数前补0
    if (parseInt(num) < 10) {
        num = '0' + num;
    }
    return num;
}

export const downloadHandler = (fileType, reportName) => {
  // const commonUrl = '/UnitPrice/downloadReport'
  const commonUrl = '/api/unit-prices/download'
  const fullUrl = commonUrl + '?fileType=' + fileType + '&reportName=' + reportName

  window.location.href = fullUrl
}

export const historicalDownloadHandler = (fileType, reportName, fund, fromDate, toDate) => {
    let fromParameter = moment(fromDate,"DD/MM/YYYY");
    let toParameter = moment(toDate,"DD/MM/YYYY");
  const commonUrl = '/api/historical-unit-prices/download'
  const fullUrl = commonUrl + '?fileType=' + fileType + '&fund=' + fund + '&reportName=' + reportName + '&fromDate=' + fromParameter.format("DD/MM/YYYY") + '&toDate=' + toParameter.format("DD/MM/YYYY");

  window.location.href = fullUrl
}

export const checkNumberOnly = (value) => {
  try {
    const regex = /^[0-9]*$/g; // number only
    return regex.test(value);
  } catch (error) {
    return false;
  }
};
